export default __webpack_public_path__ + "static/media/powertoolsLogo.4b69fd92.png";